import { IconComponentsProps } from './types';

const RunningETLJobIcon = ({ fill = '#008EFF', ...props }: IconComponentsProps) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7 0C5.61553 0 4.26216 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32122C0.00303298 5.6003 -0.13559 7.00776 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C13.9979 5.14413 13.2597 3.36486 11.9474 2.05256C10.6351 0.74026 8.85588 0.00209095 7 0ZM7 13C5.4087 13 3.88258 12.3679 2.75736 11.2426C1.63214 10.1174 1 8.5913 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1V7L11.2406 11.2407C10.6845 11.7988 10.0236 12.2415 9.29582 12.5434C8.56809 12.8453 7.78788 13.0005 7 13Z"
      fill={fill}
    />
  </svg>
);

export default RunningETLJobIcon;
